import { render, staticRenderFns } from "./TextLabelThresholdEdit.vue?vue&type=template&id=345e1ec6&scoped=true"
import script from "./TextLabelThresholdEdit.vue?vue&type=script&lang=js"
export * from "./TextLabelThresholdEdit.vue?vue&type=script&lang=js"
import style0 from "./TextLabelThresholdEdit.vue?vue&type=style&index=0&id=345e1ec6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345e1ec6",
  null
  
)

export default component.exports